var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextMusicIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.65644 6.62366C7.11053 7.02317 7.11053 7.83813 7.65644 8.23764L10.7825 10.5253C11.4431 11.0088 12.373 10.537 12.373 9.71834V5.14296C12.373 4.32431 11.4431 3.8525 10.7825 4.33597L7.65644 6.62366Z",
    fill: "#4CB5AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58271 6.62366C3.0368 7.02317 3.0368 7.83813 3.58271 8.23764L6.70875 10.5253C7.36939 11.0088 8.29932 10.537 8.29932 9.71834L8.29932 5.14296C8.29932 4.32431 7.36939 3.8525 6.70875 4.33597L3.58271 6.62366Z",
    fill: "#4CB5AA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextMusicIcon);
export default __webpack_public_path__ + "static/media/next-music-icon.74c22f2075fec47b2e9c6a36fbbc3921.svg";
export { ForwardRef as ReactComponent };